import React from "react";
//
export default function Header({ title }) {
  return <h1 className="mb-4">{title}</h1>;
}
